<!--
  Landingpage „Automatenladen“. Winkel: Geschäftsmodell 24/7-Laden ohne
  Personal, oft aus mehreren Automaten. Referenz: Automatenkiosk Langenargen
  (2 marktbox + 8 weitere Automaten; marktbox am flexibelsten, ideal für Bündel).
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🏪</div>
      <span class="lp-eyebrow" i18n="@@alad.hero.eyebrow">24/7-Verkauf · ohne Personal</span>
      <h1 class="title display" i18n="@@alad.hero.h1">Automatenladen eröffnen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@alad.hero.lead">
        Dein eigener Laden, der rund um die Uhr verkauft – ganz ohne Personal. Die
        <span class="tm">marktbox</span> lässt sich mit weiteren Automaten zu einem Automatenkiosk
        kombinieren und ist dabei am flexibelsten für unterschiedliche Waren.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@alad.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#modell" (click)="scrollTo($event, 'modell')" i18n="@@alad.hero.ctaAnchor">So funktioniert's ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox im Automatenladen – 24/7-Verkauf ohne Personal" i18n-alt="@@alad.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@alad.hero.badge">🔑 rund um die Uhr offen</span>
    </figure>
  </div>
</section>

<!-- ===== So funktioniert ein Automatenladen ===== -->
<section id="modell" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@alad.how.h2">Ein Laden aus Automaten</h2>
    <p class="lp-intro reveal" i18n="@@alad.how.intro">
      In einem Automatenladen stehen mehrere Automaten zusammen und bilden einen kompletten
      Verkaufsraum ohne Öffnungszeiten. Beim Automatenkiosk Langenargen läuft die marktbox etwa neben
      acht weiteren Automaten – und deckt genau das ab, was die anderen nicht können.
    </p>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🧩</span>
        <h3 i18n="@@alad.card1.h3">Kombinier- &amp; erweiterbar</h3>
        <p i18n="@@alad.card1.p">Starte klein und erweitere Stück für Stück: Die marktbox lässt sich mit weiteren Automaten – auch anderer Hersteller – zu einem wachsenden Sortiment kombinieren.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📦</span>
        <h3 i18n="@@alad.card2.h3">Flexibel bis zum Bündel</h3>
        <p i18n="@@alad.card2.p">Von Einzelartikeln bis zu Gebinden wie einem 6er-Bier – die marktbox ist am vielseitigsten.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">👥</span>
        <h3 i18n="@@alad.card3.h3">Kein Personal nötig</h3>
        <p i18n="@@alad.card3.p">Verkauf läuft 24/7 automatisch – bargeldlos, mit digitalem Nachweis jeder Zahlung.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🔒</span>
        <h3 i18n="@@alad.card4.h3">Sicher &amp; wetterfest</h3>
        <p i18n="@@alad.card4.p">Abschließbare Klappen und robuste Bauweise – drinnen wie draußen.</p>
      </div>
    </div>
    <p class="lp-fineprint reveal" i18n="@@alad.how.kioskLink">
      Neu beim Thema? <a [routerLink]="['/', 'automatenkiosk']">So funktioniert ein Automatenkiosk – Schritt für Schritt</a>.
    </p>
  </div>
</section>

<!-- ===== Live-Link: Langenargen ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@alad.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@alad.live.h2">Ein echter Automatenladen</h2>
      <p class="lp-lead" i18n="@@alad.live.lead">
        So sieht's live aus: der Automatenkiosk Langenargen mit der marktbox. Kundschaft sieht in
        Echtzeit, was gerade verfügbar ist.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@alad.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@alad.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@alad.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@alad.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Automatenkiosk Langenargen: Echtzeit-Verfügbarkeit" i18n-title="@@alad.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@alad.live.cap">Live-Beispiel: Automatenkiosk Langenargen</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@alad.price.h2">Automat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@alad.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@alad.price.buyText">Einmalige Investition – ideal, wenn der Laden dauerhaft an einem Standort läuft.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@alad.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@alad.price.rentText">Klein starten, später erweitern – planbare Kosten für den Aufbau deines Ladens.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@alad.price.cta">Zum Shop</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@alad.price.fine">
      Mehr zum Trend: <a [routerLink]="['/', links.blog, blogSlug]">Mit einem Automaten-Kiosk voll im Trend</a>
    </p>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@alad.faq.h2">Häufige Fragen zum Automatenladen</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@alad.final.h2">Bereit für deinen Automatenladen?</h2>
    <p class="lp-lead" i18n="@@alad.final.lead">Starte mit der flexibelsten Box und wachse Automat für Automat.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@alad.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
